import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../account/components/ProtectedRoute";
import { CheckoutCancelledPage } from "./pages/CheckoutCancelledPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { CheckoutSuccessPage } from "./pages/CheckoutSuccessPage";

export function CheckoutRoutes() {
  return (
    <Routes>
      <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
      <Route path="/checkout/cancelled" element={<CheckoutCancelledPage />} />
      <Route path="/checkout/:planSlug" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
    </Routes>
  );
}
